import { auth, firestore } from '@/firebase'
import store from '@/store'
import { VueConstructor } from 'vue/types/umd'

const collections = {
  applications: {
    unregister: () => null
  },
  cameras: {
    unregister: () => null
  },
  clients: {
    unregister: () => null
  },
  edits: {
    unregister: () => null
  },
  locations: {
    unregister: () => null
  },
  maps: {
    unregister: () => null
  },
  partners: {
    unregister: () => null
  },
  projects: {
    unregister: () => null
  },
  sequences: {
    unregister: () => null
  },
  streams: {
    unregister: () => null
  },
  systems: {
    unregister: () => null
  },
  users: {
    unregister: () => null
  },
  videos: {
    unregister: () => null
  },
  views: {
    unregister: () => null
  }
}

auth.onAuthStateChanged(async user => {
  if (user) {
    try {
      const token = await user.getIdTokenResult()
      const claims = token.claims
      const _user = {
        id: user.uid,
        isSuper: claims.super,
        partner: claims.partner,
        client: claims.client,
        permissions: claims.permissions
      }
      Object.keys(collections).forEach(collection => snapshot(collection, _user))
    } catch (err) {
      window.console.error(err)
    }
  } else {
    Object.values(collections).forEach(collection => {
      collection.unregister()
    })
  }
})

const userHasReadPermission = (permission, permissions) => {
  return permissions.indexOf(permission) > -1 || permissions.indexOf(`${permission.split(':')[0]}:super`) > -1
} 

const snapshot = (collection, user) => {
  if (userHasReadPermission(`read:${collection}`, user.permissions)) {
    const ref = firestore.collection(collection)
    let query
    if (user.isSuper) {
      query = ref
    } else if (user.partner) {
      query = ref.where("partners", "array-contains", user.partner)
    } else if (user.client) {
      query = ref.where("clients", "array-contains", user.client)
    } else {
      query = ref.where("users", "array-contains", user.id)
    }
      collections[collection].unregister = query.onSnapshot(snapshot => {
        const docs:{_id: string, [key:string]: any}[] = []
        if (snapshot.size) {
          snapshot.forEach(doc => {
            docs.push({...doc.data(), _id: doc.id})
          })
        }
        store.state[collection] = docs
      }, err => {
        throw err
      })
  }
}

export default {
  install(Vue: VueConstructor) {
    Vue.prototype.$_data = collections
  }
}
